import { NavLink as RouterNavLink, useLocation, useMatch, useResolvedPath } from 'react-router-dom'
import { Icon, IconName } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Badge, Box, NavLink, Title, useMantineColorScheme } from 'summon-ui/mantine'
import { useViewer } from '@hooks'
import { NAVIGATION_MENU } from '@layouts/DashboardLayout/constants'

const getTutorialSelector = (linkItem: string) => {
  if (linkItem === 'Quests') {
    return 'nav-button_Quests'
  } else if (linkItem === 'Proposals') {
    return 'nav-button_Proposals'
  }
  return null
}

const NavigationMenu = ({ isSmall }: { isSmall: boolean }) => {
  const { pathname } = useLocation()
  const t = useTranslation()
  const { colorScheme } = useMantineColorScheme()
  const { isAuthenticated } = useViewer()

  return (
    <>
      {NAVIGATION_MENU.map(({ iconName, soon, isNew, locked = false, ...link }) => {
        const tutorialSelectorId = !soon && getTutorialSelector(link.name)
        const isLocked = !isAuthenticated && locked
        const resolvedPath = useResolvedPath(link.to)
        const match = useMatch({ path: resolvedPath.pathname, end: true })
        const isActive = (match && !soon && !isLocked) || false

        return (
          <NavLink
            key={link.name}
            component={RouterNavLink}
            to={soon || isLocked ? pathname : link.to}
            data-testid={`navigation-menu-${link.name}-link`}
            leftSection={<Icon c={colorScheme === 'light' ? 'gray.7' : 'white'} name={iconName as IconName} />}
            w={isSmall ? 50 : '100%'}
            active={isActive}
            disabled={soon || isLocked}
            pos='relative'
            {...(isSmall
              ? {}
              : {
                  label: (
                    <Title order={6} tt='uppercase'>
                      {link.name}
                    </Title>
                  )
                })}
            {...(soon && !isSmall ? { rightSection: <Badge size='xs'>{t('Soon')}</Badge> } : {})}
            {...(isNew
              ? {
                  rightSection: !isSmall ? (
                    <Badge size='xs' bg='yellow.1' c='black'>
                      {t('New')}
                    </Badge>
                  ) : (
                    <Box pos='absolute' right={-5} bottom={-5}>
                      <Icon name='Star06' c='black' size='xs' variant='light' bg='yellow.2' />
                    </Box>
                  )
                }
              : {})}
            {...(isLocked && !isSmall ? { rightSection: <Icon name='Lock01' /> } : {})}
            {...(tutorialSelectorId ? { id: tutorialSelectorId } : {})}
          />
        )
      })}
    </>
  )
}

export default NavigationMenu
